import { render, staticRenderFns } from "./PushSubscribers.vue?vue&type=template&id=01cf587a&"
import script from "./PushSubscribers.vue?vue&type=script&lang=ts&"
export * from "./PushSubscribers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports